import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Cookies from 'js-cookie'

const routes: Array<RouteRecordRaw> = [
    { 
        path: '/', 
        component: () => import('@/views/index.vue')
    },
    {
        path: '/book_cover',
        component: () => import('@/views/book_cover.vue')
    },
    {
        path: '/read_book',
        component: () => import('@/views/read_book.vue')
    },
    {
        path: '/stack',
        component: () => import('@/views/stack.vue')
    },
    {
        path: '/works',
        component: () => import('@/views/works.vue'),
        meta: {
            title: '作品列表'
        }
    },
    {
        path: '/search',
        component: () => import('@/views/search.vue')
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

router.beforeEach((to, from, next) => {
    const title = (to.meta && typeof to.meta.title === 'string') ? to.meta.title : '好书云'; // 设置默认标题
    document.title = title;
    next();
});

export default router;


